import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
// import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import Delete from '../Delete/Delete.js';
// import Drp_StoreRoom from '../StoreRoom/Drp_StoreRoom_Simple.js'

const InventoryCountingIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const [CountingList, setCountingList] = useState([]);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    // const [Id, setId] = useState();
    // const [StoreRoomId, setStoreRoomId] = useState(-1);
    // const [Title, setTitle] = useState('');
    // const [CountingDate, setCountingDate] = useState(moment(new Date()));
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    //#endregion

    //#region Methods

    const GetAll = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/InventoryCounting/GetByFiscalYear', {
                method: 'Post',
                headers: {
                    'ApiKey': General.APIKey(),
                    'FiscalYearId': FiscalYearId,
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            Id: result[i].id,
                            Title: result[i].title,
                            CountingDate: result[i].countingDate,
                            StoreRoomId: result[i].storeRoomId,
                            StoreRoom: result[i].storeRoom,
                            Number: result[i].number,
                            CreateUser: result[i].createUser,
                            State: result[i].state,
                            StateComment: result[i].stateComment,

                        })
                    }
                    setCountingList(tmp)
                })
        )
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };



    const ShowDelete = (id, title) => {
        DeleteRef.current.Get(41, id, title);
    }

    const ShowEdit = (id, state) => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 41);
        myHeaders.append("Operation", 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() == "OK") {
                        localStorage.setItem("InventoryCountingId", id)
                        localStorage.setItem("InventoryCountingState", state)
                        navigate("/InsertInventoryCounting");
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.toString())), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const ShowNew = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 41);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() == "OK") {
                        localStorage.setItem("InventoryCountingId", General.GuidEmpty())
                        localStorage.setItem("InventoryCountingState", 0)

                        navigate("/InsertInventoryCounting");
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.toString())), 'topCenter')
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const ShowPrint = (id, state) => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 41);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() == "OK") {
                        localStorage.setItem("InventoryCountingId", id)
                        localStorage.setItem("InventoryCountingState", state)
                        navigate("/InventoryCountingPrint");
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.toString())), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 41);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        GetAll();

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    useEffect(() => {
        CheckPermission();
        document.title = "انبار گردانی";
    }, [])
    //#endregion







    return (

        <Layout title='انبار گردانی'>


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    height={420}
                                    data={CountingList.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                    loading={loading}

                                >
                                    <rsuite.Table.Column className="w-10p" align="center" fixed sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Row" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>شماره انبارگردانی</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Number" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={4} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Title" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={2} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>انبار</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="StoreRoom" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={1} sortable resizable>
                                        <rsuite.Table.HeaderCell>تاریخ</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="CountingDate" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={1} sortable resizable>
                                        <rsuite.Table.HeaderCell>وضعیت</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="StateComment" />
                                    </rsuite.Table.Column>




                                    <rsuite.Table.Column width={60} fixed="right" >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item className={rowData.State == 0 ? '' : 'hide'} onClick={() => ShowEdit(rowData.Id, rowData.State)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.State == 0 ? '' : 'hide'} onClick={() => ShowDelete(rowData.Id, rowData.Title)}>حذف</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.State <= 3 ? '' : 'hide'} onClick={() => ShowEdit(rowData.Id, rowData.State)}>نمایش شمارش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.State != 0 ? '' : 'hide'} onClick={() => ShowEdit(rowData.Id, rowData.State)}> چاپ</rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >


            <Delete ref={DeleteRef} onSubmit={GetAll} />
        </Layout >


    )
}

export default InventoryCountingIndex;